import { styled, Typography } from '@mui/material';

export const SearchRefinementListTypographyStyled = styled(Typography)(() => ({
  maxWidth: '30ch', // Approximate width for 30 characters
  overflow: 'hidden', // Hides overflow content
  whiteSpace: 'nowrap', // Prevents text from wrapping to the next line
  textOverflow: 'ellipsis', // Adds "..." at the end if text is truncated
}));
